import styled from "styled-components";

export const StyledCrmEnrichmentJobSettingsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 42px;
    margin: 24px 0;
`;
